import React from "react";
import FaqOne from "../component/faq/FaqOne";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import FooterOne from "../common/footer/FooterOne";
import AboutThree from "../component/about/AboutThree";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ClientSlider from "../component/client/ClientSlider";

const FAQs = () => {
  return (
    <>
      <SEO title="FAQs" />

      <main className="main-wrapper">
        <HeaderOne />

        <BreadCrumbOne subtitle="" title="FAQs" page="FAQs" />

        <FaqOne />

        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>

        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default FAQs;
